import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children", "containerRef"],
  _excluded2 = ["children", "containerRef"],
  _excluded3 = ["children"];
import { Box } from '@wix/design-system';
import React from 'react';
export const TldOfferWidgetLayout = {
  StripContainer: _ref => {
    let children = _ref.children,
      containerRef = _ref.containerRef,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/React.createElement(Box, _extends({
      ref: containerRef,
      direction: "vertical",
      padding: "SP6",
      marginTop: "SP4",
      marginBottom: "SP4",
      borderRadius: "12px"
    }, props), children);
  },
  CarouselStripContainer: _ref2 => {
    let children = _ref2.children,
      containerRef = _ref2.containerRef,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return /*#__PURE__*/React.createElement(Box, _extends({
      ref: containerRef,
      direction: "vertical",
      gap: "SP4",
      padding: "SP4 0",
      marginTop: "SP4",
      marginBottom: "SP4",
      borderRadius: "12px",
      border: "1px solid var(--wds-color-black-550)",
      boxShadow: "-5px 6px 33px 0 rgba(0, 0, 0, 0.02)"
    }, props), children);
  },
  CardContainer: _ref3 => {
    let children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "vertical",
      gap: "12px",
      padding: "SP3 SP4",
      height: "100%",
      borderRadius: "12px",
      backgroundColor: "white"
    }, props), children);
  }
};
//# sourceMappingURL=tldOfferWidget.layout.js.map